import { PourConfig, CalculationResult } from '../types';

export const calculateVolume = (config: PourConfig): CalculationResult => {
  const { shape, unitSystem, dimensions, ratioA, ratioB, wasteMargin, pricePerUnit } = config;
  const { length, width, depth, diameter } = dimensions;

  let baseVolume = 0;

  // Calculate base volume in cubic inches (imperial) or cubic cm (metric)
  if (shape === 'rectangle') {
    baseVolume = length * width * depth;
  } else {
    const radius = diameter / 2;
    baseVolume = Math.PI * Math.pow(radius, 2) * depth;
  }

  // Add waste margin
  const totalVolumeRaw = baseVolume * (1 + wasteMargin / 100);

  let totalLiquidVolume = 0;
  let unitLabel = '';
  let estimatedCost = 0;

  if (unitSystem === 'imperial') {
    // 1 cubic inch = 0.554113 fluid ounces
    totalLiquidVolume = totalVolumeRaw * 0.554113;
    unitLabel = 'fl oz';
    
    // Cost Calc: Input is Price Per Gallon. 1 Gallon = 128 fl oz.
    if (pricePerUnit > 0) {
      estimatedCost = (totalLiquidVolume / 128) * pricePerUnit;
    }

  } else {
    // 1 cubic cm = 1 ml
    totalLiquidVolume = totalVolumeRaw; // in ml
    unitLabel = 'ml';

    // Cost Calc: Input is Price Per Liter. 1 Liter = 1000 ml.
    if (pricePerUnit > 0) {
      estimatedCost = (totalLiquidVolume / 1000) * pricePerUnit;
    }
  }

  // Calculate Mix Ratio
  const totalParts = ratioA + ratioB;
  const partA = (totalLiquidVolume * ratioA) / totalParts;
  const partB = (totalLiquidVolume * ratioB) / totalParts;

  return {
    totalVolume: totalLiquidVolume,
    partA,
    partB,
    unit: unitLabel,
    estimatedCost
  };
};

export const formatNumber = (num: number): string => {
  return num.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 2 });
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
};